import { initializeApp } from 'firebase/app';
import { getStorage } from 'firebase/storage';
import { getFirestore } from 'firebase/firestore';
import { getDatabase } from 'firebase/database';
import { getAuth } from 'firebase/auth';
import { getFunctions } from 'firebase/functions';
import { requiredRuntimeValue } from '../config/runtime';


const firebaseConfig = {
    apiKey: requiredRuntimeValue("REACT_APP_FIREBASE_API_KEY"),
    authDomain: requiredRuntimeValue("REACT_APP_FIREBASE_AUTH_DOMAIN"),
    databaseURL: requiredRuntimeValue("REACT_APP_FIREBASE_DATABASE_URL"),
    projectId: requiredRuntimeValue("REACT_APP_FIREBASE_PROJECT_ID"),
    storageBucket: requiredRuntimeValue("REACT_APP_FIREBASE_STORAGE_BUCKET"),
    messagingSenderId: requiredRuntimeValue("REACT_APP_FIREBASE_MESSAGING_SENDER_ID"),
    appId: requiredRuntimeValue("REACT_APP_FIREBASE_APP_ID"),
};

const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const database = getDatabase(app)
export const functions = getFunctions(app);
